import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { MotionGlobalConfig } from "framer-motion";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);

const container = document.getElementById("root");
const isPrerender = typeof window !== "undefined" && window.__PRERENDER__ === true;
const wasPrerendered = container.hasChildNodes();

// Render entrance animations in their final visible state during the prerender
// snapshot and during the initial client mount of a prerendered page. This
// keeps the fresh client render pixel-identical to the static HTML (no flash)
// and guarantees no invisible opacity:0 content in the raw HTML.
if (isPrerender || wasPrerendered) {
  MotionGlobalConfig.skipAnimations = true;
  window.__WP_STATIC__ = true;
}

// We intentionally use createRoot (not hydrateRoot). The prerender snapshot is a
// client render (framer-motion / DOM need a real browser), so its useId-based
// Radix attributes are client-style and would not match hydrateRoot — causing
// hydration-mismatch warnings. createRoot replaces the static markup with an
// identical final-state render (seamless), then animations are re-enabled.
ReactDOM.createRoot(container).render(tree);

if (wasPrerendered && !isPrerender) {
  requestAnimationFrame(() =>
    requestAnimationFrame(() => {
      MotionGlobalConfig.skipAnimations = false;
      window.__WP_STATIC__ = false;
    })
  );
}
